'use strict';

import LazyLoad from "vanilla-lazyload";

const lazyLoadInstance  = new LazyLoad({
    elements_selector:".lazy",
    effect : "fadeIn"
});

//register a event when new image source loaded reinitialize lazy load again
$(document).on('lazy-load-src-changed', function () {
    // console.log("lazy-loading-images changed");
    if(lazyLoadInstance) {
        lazyLoadInstance.update();
    }
});

if(lazyLoadInstance){
    lazyLoadInstance.update();
}
